import React from "react";
import Combos from "@/components/Combos";

export default function ComboPage() {
  return (
    <div className="pt-24 min-h-screen">
      <Combos />
    </div>
  );
}
